import React, { FunctionComponent, useState } from 'react';
import styles from './CompareVideo.module.scss';
import { _t } from 'app/utils/i18n';
import bookmark from 'app/assets/images/bookmark.svg';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  makeStyles,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { nFormatter } from 'app/utils/numbersFormater';
import { dateTimeFormatter } from 'app/utils/dateTimeFormatter';

import { getFromLocalStorage } from 'app/utils/localStorage';
import { checkTranslated } from 'app/utils/helpers';
import { useAppSettings } from 'app/context/settings/appSettings';
import AddComment from 'reports/components/AddComment';

interface Props {
  compareVideoDetails: any;
  compId: string;
  currentIndex: number;
  handleOpen?: any;
  isReport: boolean;
  isEnForTest?: boolean;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontWeight: theme.typography.fontWeightRegular,
    textTransform: 'capitalize',
  },
}));
const CompareVideo: FunctionComponent<Props> = ({
  compareVideoDetails,
  compId,
  currentIndex,
  handleOpen,
  isReport,
  isEnForTest,
}) => {
  const classes = useStyles();
  const { theme } = useAppSettings();
  const [expanded, setExpanded] = useState(false);
  const handleChange = () => {
    setExpanded(!expanded);
  };
  const isEn = getFromLocalStorage('LNG') == 'en' || isEnForTest ? true : false;
  const [activeTab, setActiveTab] = useState(isEn ? 'en' : 'ar');

  const { influencer } = compareVideoDetails;
  const renderInfluencerName = () => {
    return influencer?.id
      ? influencer?.name
        ? `${checkTranslated(
            influencer?.name?.original,
            influencer?.name?.arabic,
            activeTab
          )} / ${influencer?.is_entity ? _t('entity') : _t('influencer')}`
        : '-'
      : '-';
  };
  const newLineFormatter = (text: string) => {
    return text?.replace(/\\n/gi, '\n').replace(/\n/gi, '\n');
  };
  return (
    <Grid className={styles.CompareVideo} id={`${compId}-compVid`}>
      {/* BOX HEADER */}
      {compareVideoDetails?.title_translated && (
        <div className={styles.Tabs} data-testid="tabs-holer">
          <div
            className={`${styles.Tabs__ArTab} ${
              activeTab === 'ar' ? styles.active : null
            }`}
            onClick={() => setActiveTab('ar')}
            data-testid="arabic-holer"
          >
            AR
          </div>
          <div
            className={`${styles.Tabs__EnTab} ${
              activeTab === 'en' ? styles.active : null
            }`}
            onClick={() => setActiveTab('en')}
            data-testid="english-holer"
          >
            EN
          </div>
        </div>
      )}
      <div className={styles.commentContainer}>
        {isReport && <AddComment removePosition compId={`${compId}-compVid`} />}
      </div>

      <div
        className={styles.compareVideoHeader}
        id={`${compId}-compVidHeader `}
      >
        <div className={styles.VideoName} data-testid="video-name-holder">
          <a
            href={compareVideoDetails.postDetailsLink}
            className="videoTitle"
            title={checkTranslated(
              compareVideoDetails?.title,
              compareVideoDetails?.title_translated,
              activeTab
            )}
          >
            {checkTranslated(
              compareVideoDetails?.title,
              compareVideoDetails?.title_translated,
              activeTab
            )}
          </a>
          {currentIndex !== undefined && (
            <div
              className={styles.VideoName__ColorBox}
              style={{
                borderColor: theme.colors.chartsColors[currentIndex],
                backgroundColor: theme.colors.chartsColors[currentIndex],
              }}
            ></div>
          )}
        </div>
        <div data-testid="bookmark-holder">
          <img src={bookmark} alt="bookmarkIcon" />
        </div>
      </div>

      {/* BOX DETAILS */}
      <div
        className={styles.compareVideoDetails}
        id={`${compId}-compVidDetails `}
      >
        {/* LEFT SIDE */}
        <div
          className={styles.compareVideoImg}
          id={`${compId}-compVid-img `}
          onClick={() => {
            handleOpen();
          }}
          data-testid="video-holder"
        >
          <div>
            <img src={compareVideoDetails.image} alt=" image alt" />
          </div>
          <div className={styles.VideoBtn}>
            <PlayArrowIcon />
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div
          className={styles.videoContent}
          id={`${compId}-compVid-content `}
          data-testid="content-holder"
        >
          <div className={styles.compareVideoInfo}>
            <div className={`${styles.sectionSeparator} ${styles.countsData}`}>
              <div data-testid="views-holder">
                <h3 className={styles.infoTitle}>{_t('trends:views')}</h3>
                <p className={styles.counts}>
                  {nFormatter(compareVideoDetails?.views_count)}
                </p>
              </div>
              {/* <div>
                <h3 className={styles.infoTitle}>{_t('trends:dislikes')}</h3>
                <p className={styles.counts}>
                  {nFormatter(compareVideoDetails?.dislikes_count)}
                </p>
              </div> */}
              <div data-testid="likes-holder">
                <h3 className={styles.infoTitle}>{_t('trends:likes')}</h3>
                <p className={styles.counts}>
                  {nFormatter(compareVideoDetails?.likes_count)}
                </p>
              </div>
              <div data-testid="comments-holder">
                <h3 className={styles.infoTitle}>{_t('trends:comments')}</h3>
                <p className={styles.counts}>
                  {nFormatter(compareVideoDetails?.comments_count)}
                </p>
              </div>
            </div>
            <div
              className={`${styles.sectionSeparator} ${styles.middleSection}`}
            >
              <div data-testid="source-holder">
                <h3 className={styles.infoTitle}>{_t('trends:source')}:</h3>
                <p>{renderInfluencerName()}</p>
              </div>
              <div data-testid="platform-holder">
                <h3 className={styles.infoTitle}>{_t('trends:platform')}:</h3>
                <p>
                  {checkTranslated(
                    compareVideoDetails?.platforms?.[0]?.name,
                    compareVideoDetails?.platforms?.[0]?.name_translated,
                    activeTab
                  )}
                </p>
              </div>
            </div>
            <div
              className={`${styles.sectionSeparator} ${styles.middleSection}`}
            >
              <div data-testid="channel-name-holder">
                <h3 className={styles.infoTitle}>
                  {_t('trends:youtube_channel')}:
                </h3>
                <p>
                  {checkTranslated(
                    compareVideoDetails?.channel?.name,
                    compareVideoDetails?.channel?.name_translated,
                    activeTab
                  )}
                </p>
              </div>
              <div data-testid="subscribers-holder">
                <h3 className={styles.infoTitle}>
                  {_t('trends:subscribers')}:
                </h3>
                <p className={styles.videoDetailsInfo}>
                  {nFormatter(compareVideoDetails?.channel?.subscriber_count)}{' '}
                  <span className={styles.videoDetails}>
                    {_t('trends:subs')}{' '}
                  </span>
                </p>
              </div>
            </div>
            <div
              className={`${styles.sectionSeparator} ${styles.middleSection} ${styles.videoUploadedSection}`}
            >
              <div data-testid="uploaded-video-holder">
                <h3 className={styles.infoTitle}>
                  {_t('trends:uploaded_video')}
                </h3>
                <p className={styles.videoDetailsInfo}>
                  {nFormatter(compareVideoDetails?.channel?.uploaded_count)}{' '}
                  <span className={styles.videoDetails}>
                    {_t('trends:uploads')}
                  </span>
                </p>
              </div>
              <div data-testid="joined-holder">
                <h3 className={styles.infoTitle}>{_t('trends:joined')}</h3>
                <p>
                  {dateTimeFormatter.date(
                    compareVideoDetails?.channel?.joined_at
                  )}
                </p>
              </div>
              <div data-testid="total-views-holder">
                <h3 className={styles.infoTitle}>{_t('trends:total_views')}</h3>

                <p>
                  {nFormatter(compareVideoDetails?.channel?.views_count)}{' '}
                  <span className={styles.videoDetails}>
                    {_t('trends:view')}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!isReport && (
        <div
          className={`${classes.root} ${styles.compareVideoCollapse}`}
          data-testid="details-holder"
        >
          <Accordion onChange={handleChange}>
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon style={{ fill: 'var(--mainColor)' }} />
              }
              aria-controls="panel1a-content"
              id="panel1a-header"
              data-testid="accordion-holder"
            >
              <Typography className={classes.heading}>
                {expanded ? _t('basic:see_less') : _t('basic:see_more')}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div
                className={styles.accordionContent}
                data-testid="post-holder"
              >
                <h3 className={styles.infoTitle}>{_t('trends:post')}</h3>
                <pre
                  dangerouslySetInnerHTML={{
                    __html: checkTranslated(
                      newLineFormatter(compareVideoDetails?.post),
                      newLineFormatter(compareVideoDetails?.post_translated),
                      activeTab
                    ),
                  }}
                  data-testid="post-content-holder"
                />
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      )}
      {/* COLLAPSE */}
    </Grid>
  );
};

export default CompareVideo;
